<template>
    <div>
        <el-select v-model="form.country" filterable :disabled="loading" @change="formatData">
            <el-option v-for="c in country_list" :key="c.code" :value="c.code"
                       :label="c.en_name + ' (' + c.code + ')'">
                {{ c.en_name + ' (' + c.code + ')' }}
            </el-option>
        </el-select>
        <el-date-picker value-format="YYYY-MM-DD" v-model="form.date" :disabled="loading"
                        @change="init"></el-date-picker>
    </div>
    <vue-draggable-next v-model="data_filter" :animation="300" handle=".handle" @change="sort(data_filter)">
        <template v-for="d in data_filter">
            <div class="handle" style="display: inline-block;position: relative">
                <el-image lazy style="width: 200px;margin: 10px"
                          :src="`https://jigsaw-cdn.plutodesk.com/${d.thumbnail}`"></el-image>
                <el-icon @click="loading?null:remove(d)"
                         style="position: absolute; top: 5px; right: 5px; cursor: pointer; color: var(--el-color-danger)">
                    <CircleClose/>
                </el-icon>
            </div>
        </template>
    </vue-draggable-next>
</template>

<script>
import axios from "ts-axios-new";
import {VueDraggableNext} from 'vue-draggable-next'
import {timestampToDate} from "../libs/utils";

export default {
    name: "CountryHot",
    components: {VueDraggableNext},
    data() {
        const now = Date.now();
        return {
            loading: false, data: [], country_list: [], data_filter: [],
            form: {
                country: 'US', date: timestampToDate(now),
            },
        }
    },
    methods: {
        init() {
            this.loading = true;
            axios.all([
                axios.get('/cms/v1/country/hot', {params: this.form}).then(res => {
                    this.country_list = [];
                    this.data = res.data.data.imageList;
                    this.$root.country_list.forEach(c => {
                        let valid = false;
                        res.data.data.imageList.forEach(i => {
                            if (i.country === c.code) {
                                valid = true;
                            }
                        });
                        if (valid) {
                            this.country_list.push(c);
                        }
                    });
                }),
            ]).then(_ => {
                this.$root.country_list.forEach(c => {
                    let valid = false;
                    this.data.forEach(d => {
                        if (d.country === c.code) {
                            valid = true;
                        }
                    });
                    if (valid) {
                        this.country_list.push(c);
                    }
                })
                this.formatData();
                this.loading = false;
            })
        },
        formatData() {
            this.data_filter = this.data.filter(d => d.country === this.form.country);
        },
        sort(images) {
            const sort = [];
            images.forEach(i => {
                sort.push(i.id);
            });
            this.loading = true;
            axios.post(`/cms/v1/sort/country/hot`, {sort}).then(res => {
                this.loading = false;
            })
        },
        remove(row) {
            this.loading = true;
            axios.delete(`cms/v1/country/hot/${row.id}`).then(res => {
                this.init()
            });
        },
    },
    mounted() {
        this.init();
    },
}
</script>

<style scoped>

</style>